type ViteEnv = {
  PROD: boolean;
  VITE_GOOGLE_MAPS_GEOCODING_API_KEY: string;
  VITE_SENTRY_DSN?: string;
  VITE_SENTRY_ENV?: string;
  VITE_WEATHERLAYERS_API_KEY: string;
  VITE_STATIC_TILE_CACHE_DOMAIN: string;
  VITE_ALTERNATE_STATIC_TILE_CACHE_DOMAIN: string;
  VITE_TILE_SERVER_URL: string;
  VITE_FIREBASE_ANALYTICS_WEB_CONFIG: string;
  VITE_MAPBOX_ACCESS_TOKEN: string;
  VITE_RECURLY_PUBLIC_TOKEN: string;
  VITE_RADIO_TOWERS_URL: string;
  VITE_MAPBOX_API: string;
  VITE_AIRCRAFT_TRACE_ENDPOINT: string;
  VITE_AIRCRAFT_LIST_ENDPOINT: string;
  VITE_AIRCRAFT_CDN_ENDPOINT: string;
  VITE_USE_NEW_STORAGE: boolean;
  VITE_BASE_API_URL: string;
  VITE_BASE_SHARE_URL: string;
  VITE_BASE_WEB_URL: string;
  VITE_GIT_TAG?: string;
  VITE_SENTRY_RELEASE_VERSION: string;
  VITE_ENV: string;
  VITE_MOCK_PUSH_TOKEN?: boolean;
  VITE_FORCE_UPDATE_AVAILABLE: boolean;
  VITE_POSTHOG_PUBLIC_KEY: string;
  VITE_POSTHOG_ENV?: string;
  VITE_3D_MAPS_ENABLED: boolean;
  VITE_SKIP_INBOX_MESSAGE_CHECKS?: boolean;
};

const coerceEnvValue = (value: string): string | number | boolean => {
  // Convert any true/false strings to booleans, which aren't supported by the
  // native import.meta.env object.
  if (['true', 'false'].includes(value)) {
    return value === 'true';
  }

  if (!Number.isNaN(Number(value))) {
    return Number(value);
  }

  return value;
};

export const ENV: ViteEnv = Object.fromEntries(
  Object.entries(import.meta.env).map(([key, value]) => [
    key,
    coerceEnvValue(value),
  ]),
) as ViteEnv;
